/* tslint:disable */
 
import { ReferencePropertyWithResolved } from './reference-property-with-resolved';
export class SystemLog {

  /**
   * The details of the log.
   */
  details: any;

  /**
   * The time the action was performed.
   */
  doneAt: string;
  doneBy: ReferencePropertyWithResolved;
  id?: string;
}
